import { GET_PRODUCT_PRODUCTSPEC } from "../constants/endpoints";
import axiosClient from "./axios";

class fetchProductSpec {
  static async getProductSpec() {
    return await axiosClient.get(GET_PRODUCT_PRODUCTSPEC);
  }
}

export default fetchProductSpec;
